export default __webpack_public_path__ + "static/media/offgridsolar.9396d48d.jpg";